
import { mapGetters } from 'vuex';

export default {
  name: 'gifts-block',
  computed: mapGetters(['getStaticLanguage']),
};
